/**
 * Company Controls Mapper
 * Maps transport layer DTOs to domain models
 */

import type { LC_GetCompanyControlsOut, CompanyControl } from './companyControls.types';


export const mapCompanyControls = (
  out: LC_GetCompanyControlsOut,
): CompanyControl[] => {
  if (!out) return [];
  return out.map((item) => ({
    id: item.controlId,
    description: item.controlName || '',
  }));
};
